import { AxiosPromise } from 'axios';
import BaseApi from '../base';
import API from "../../types/api";

const RegistrationAPI = {
  new(data: { email: string, plan: string }, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations', data, opts || {});
  },
  email(data: { email: string, plan?: string }, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/email', data, opts || {});
  },
  kyc(data: object, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/kyc', data, opts || {});
  },
  connectBA(data: object, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/connect_bank_account', data, opts || {});
  },
  apSubscription(data: object, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/ap_subscription', data, opts || {});
  },
  prepareAPSubscription(data: object, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/prepare_ap_subscription', data, opts || {});
  },
  prepareKYC(data: { connectIK: string, customerIK: string}, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/prepare_kyc', data, opts || {});
  },
  getKYCSession(data: {}, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.get('/registrations/kyc_session', data, opts || {});
  },
  accountType(data: { accountType: string }, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.put('/registrations/account_type', data, opts || {});
  },
  status(opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.get('/registrations/status', opts || {})
  },
  completeAPSubscription(data: {attachPayoutAccount: boolean}, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.post('/registrations/complete_ap_subscription', data || {}, opts || {});
  },
  couponPricing(couponCode: string, opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.get(`/registrations/pricing?couponCode=${couponCode}`, opts || {});
  },
}

export default RegistrationAPI;
